import AbstractAccordion from './AbstractAccordion'
import { shallowRef } from 'vue'
import DocumentsComponent from '@/modules/common/common/components/insuranceAccordions/DocumentsComponent.vue'
export default class AccordionDocuments extends AbstractAccordion<string> {
  component = shallowRef(DocumentsComponent)

  constructor(attributes: Partial<AccordionDocuments>) {
    super(attributes)
  }
}
